import React from 'react';
import styled from 'styled-components';
import { objToArr } from '../../../helpers';

const Wrapper = styled.div`
  position: absolute;
  top: 50%;
  transform: translate(0, -50%);
  right: 0;
  display: flex;
  flex-direction: column;
  align-items: stretch;
`;

const MenuItem = styled.div`
  transition: all 0.2s linear;
  background: ${props => (props.active ? props.color : '#ffffff')};
  color: ${props => (props.active ? '#ffffff' : props.color)};
  height: 50px;
  textalign: center;
  padding: 0 20px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  cursor: pointer;
`;

const PlayerRelatedMenu = (props) => {
  const RenderItem = item => (
    <MenuItem
      color={props.color}
      active={window.location.href.indexOf(item.url) > -1}
      onClick={() => {
        props.onClick(item.url);
      }}
    >
      {item.label}
    </MenuItem>
  );
  const items = objToArr(props.items);
  return <Wrapper>{items.map(item => RenderItem(item))}</Wrapper>;
};

export default PlayerRelatedMenu;



// WEBPACK FOOTER //
// ./src/components/Player/PlayerRelatedMenu/index.js